import { Component } from '@angular/core';
import { LoaderService } from '@services/loader/loader.service';

@Component({
    selector: 'app-loading-screen',
    templateUrl: './loading-screen.component.html',
    styleUrls: ['./loading-screen.component.scss'],
    standalone: false,
})
export class LoadingScreenComponent {
    constructor(public loader: LoaderService) {}
}
